import React, { useState } from "react";
import {
  Typography,
  Chip,
  Stack,
  Accordion,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomAccordionSummary from "styles/customAccordionSummary";

export default function QuickFilters({
  selectedContract,
  selectedStatus,
  setSelectedContract,
  setSelectedStatus,
  handleAccordionToggle,
  resetFilter,
  updateLocalStorageForFilter,
}) {
  const [resetSelected, setResetSelected] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleContractClick = (contract) => {
    setSelectedContract(contract);
    updateLocalStorageForFilter("contract", contract);
    setResetSelected(false);
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    updateLocalStorageForFilter("status", status);
    setResetSelected(false);
  };

  const handleResetFilters = () => {
    setSelectedContract("All");
    setSelectedStatus("All");
    resetFilter();
    setResetSelected(true);
  };

  const handleAccordionChange = () => {
    setExpanded(!expanded);
    handleAccordionToggle();
  };

  const isResetVisible = selectedContract !== "All" || selectedStatus !== "All";

  return (
    <div>
      <Accordion expanded={expanded} onChange={handleAccordionChange}>
        <CustomAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Quick Filters:
            </Typography>
            {isResetVisible && (
              <Button
                onClick={handleResetFilters}
                color={resetSelected ? "selectedChip" : "chip"}
              >
                Reset
              </Button>
            )}
            {/* Display selected filters only when the accordion is collapsed */}
            {!expanded && selectedContract !== "All" && (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>By Contract:</span>{" "}
                {selectedContract}
              </Typography>
            )}
            {!expanded && selectedStatus !== "All" && (
              <Typography variant="body2">
                <span style={{ fontWeight: "bold" }}>By Status:</span>{" "}
                {selectedStatus}
              </Typography>
            )}
          </Stack>
        </CustomAccordionSummary>
        <AccordionDetails>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Typography
              variant="subtitle1"
              sx={{ width: 125, fontWeight: "bold" }}
            >
              By Contract:
            </Typography>
            {["All", "GTM", "PGTM", "RTM", "SRX"].map((contract) => (
              <Chip
                sx={{ minWidth: 125 }}
                key={contract}
                label={contract}
                onClick={() => handleContractClick(contract)}
                color={selectedContract === contract ? "selectedChip" : "chip"}
              />
            ))}
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
          >
            <Typography
              variant="subtitle1"
              sx={{ width: 125, fontWeight: "bold" }}
            >
              By Prod Status:
            </Typography>
            {["All", "Active", "Inactive", "Implementation"].map((status) => (
              <Chip
                sx={{ minWidth: 125 }}
                key={status}
                label={status}
                onClick={() => handleStatusClick(status)}
                color={selectedStatus === status ? "selectedChip" : "chip"}
              />
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
